import { FC, ReactNode } from 'react'
import styled from '@emotion/styled'

const Container = styled('span')(({ theme }) => ({
  display: 'block',
  width: '100%',
  font: 'inherit',
  padding: `${theme.spacing.xs + 2}px ${theme.spacing.xs}px`,
  border: '1px solid transparent',
  borderRadius: 0,
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    borderColor: theme.colors.primary.main,
  },
}))

interface PreviewEditableValueProps {
  children: ReactNode
  onClick: () => void
}

export const PreviewEditableValue: FC<PreviewEditableValueProps> = ({ children, onClick }) => {
  return <Container onClick={onClick}>{children}</Container>
}
